export default "__VITE_ASSET__XbKMpail__"